<script setup>
import {Link} from "@inertiajs/vue3";
import ModalFrame from "@/Components/Misc/ModalFrame.vue";
import {scrollTop} from "@/utility";
</script>

<template>
	<ModalFrame @hide="hide()">

		<template #header>
			{{__('added_to_cart')}}
		</template>

		<div class="product_details d-flex gap-3 flex-column align-items-start justify-content-between flex-md-row align-items-md-center">

			<div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
				<div class="mb-3 mb-md-0 text-center">
					<img class="product_image" :src="'/storage/product_image' + $store.state.cart.recently_added_item.image" :alt="$store.state.cart.recently_added_item.title">
				</div>
			</div>

			<div class="d-flex flex-column align-items-start justify-content-start mt-1 mt-md-0">
				<span class="product-title text-large">{{$store.state.cart.recently_added_item.title}}</span>
				<span class="font-semibold text-danger text-large mt-2 mb-2" v-if="$store.state.cart.recently_added_item.price_new > 0">{{$store.state.cart.recently_added_item.price_new.toFixed(2)}} {{ $page.props.store.currency_symbol || $page.props.store.currency_code }}</span>
			</div>

		</div>

		<div class="container px-0 px-md-5 pb-0 pb-md-2 mt-2">
			<div class="row">
				<div class="col-12 col-lg-6 mb-2 mb-md-0">
					<Link id="modal_viewCartButton" class="btn btn-secondary btn-sm w-100" :href="route('cart')" @click="hide()" :onFinish="scrollTop">
						{{__('view_cart')}}
					</Link>
				</div>
				<div class="col-12 col-lg-6">
					<button class="btn btn-primary btn-sm w-100"  @click="hide()">
						{{__('continue_shopping')}}
					</button>
				</div>
			</div>
		</div>

	</ModalFrame>
</template>

<script>
export default {
	name: "ConfirmationModal",
	methods: {
		hide(){
			this.$store.commit('cart/set', { recently_added_item: null})
		}
	}
}
</script>

<style scoped>

</style>